import { twMerge } from 'tailwind-merge';
import { ClassName, ProfilePreview } from '@/types';
import { UI } from '@/Components/UI';

type ProfileImageProps = {
    user: ProfilePreview | undefined;
    className?: ClassName;
}

export const ProfileImage = ({user, className}: ProfileImageProps) => {
    return (
        <i
            className={twMerge('inline-flex justify-center items-center size-[1em] align-bottom rounded-full overflow-hidden bg-surface-2', className)}>
            {user?.profileImage ? (
                <UI.Image
                    image={user.profileImage}
                    alt={user.name}
                    className={'block size-full'}/>
            ) : (
                <UI.Icon
                    name={'person'}
                    className={'text-[0.5em]!'}/>
            )}
        </i>
    );
}
